const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('contact form') // eslint-disable-line

function MaxlengthLabel({ text, maxlength, htmlFor }) {
    return (
        <label className="maxlength" htmlFor={htmlFor}>
            {text.length}/{maxlength}
        </label>
    )
}
MaxlengthLabel.propTypes = {
    text: PropTypes.string,
    maxlength: PropTypes.number,
    htmlFor: PropTypes.string,
}

module.exports = MaxlengthLabel
